import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Avatar from "./Avatar";
import VerifiedBadge from "./VerifiedBadge";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function CommentsSection({ postId, onCountChange }) {
  const { user } = useAuth();
  const [comments, setComments] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/posts/${postId}/comments`).then(({ data }) => {
      setComments(data);
      setLoading(false);
    });
  }, [postId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    const { data } = await api.post(`/posts/${postId}/comments`, { text: text.trim() });
    const next = [...comments, data];
    setComments(next);
    onCountChange?.(next.length);
    setText("");
  };

  return (
    <div className="border-t border-[#262626] p-4 space-y-3">
      {loading ? (
        <div className="text-xs text-[#737373]">Loading comments…</div>
      ) : comments.length === 0 ? (
        <div className="text-xs text-[#737373]">No comments yet.</div>
      ) : (
        comments.map((c) => (
          <div key={c.id} data-testid={`comment-${c.id}`} className="flex gap-3">
            <Link to={`/profile/${c.author?.id}`}>
              <Avatar url={c.author?.avatar_url} name={c.author?.name} size={32} />
            </Link>
            <div className="flex-1 bg-[#0a0a0a] border border-[#262626] p-3 rounded-sm">
              <Link
                to={`/profile/${c.author?.id}`}
                className="text-xs font-semibold text-white hover:underline inline-flex items-center gap-1"
              >
                {c.author?.name}
                <VerifiedBadge role={c.author?.role} verified={c.author?.verified} size={12} />
              </Link>
              <p className="text-sm text-white/90 mt-1 whitespace-pre-wrap">{c.text}</p>
            </div>
          </div>
        ))
      )}

      {user && (
        <form onSubmit={submit} className="flex gap-2 pt-2">
          <input
            data-testid={`comment-input-${postId}`}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Add a comment…"
            className="flex-1 bg-[#0a0a0a] border border-[#262626] focus:border-[#404040] outline-none px-3 py-2 text-sm text-white placeholder:text-[#737373] rounded-sm transition-colors"
          />
          <button
            data-testid={`comment-submit-${postId}`}
            type="submit"
            className="px-4 py-2 bg-white text-black text-sm font-semibold rounded-sm hover:bg-gray-200 transition-colors"
          >
            Post
          </button>
        </form>
      )}
    </div>
  );
}
